// Yeni parola politikası — backend (Common.Types/Helpers/PasswordPolicyHelper.cs) kurallarını aynalar.
// Kural değişirse iki taraf birlikte güncellenmelidir. Backend char.IsLower/IsUpper/IsDigit
// unicode-duyarlı olduğundan burada da unicode property escape (\p{...}) kullanılır.
//
// Politika YALNIZ prod'da zorlanır (dev/test'te gerçek kullanıcı yok) — karar EnvironmentHelper'da,
// backend'deki IOrtamProvider ile aynı fail-safe mantıkla. Buradaki `zorunluMu()` yalnızca UI'ı
// serbest bırakır; asıl kapı backend'dir.

import EnvironmentHelper from "../../helpers/EnvironmentHelper";

export interface IPasswordPolicyRule {
    gecerli: boolean;
    mesaj: string;
}

export default class PasswordPolicyHelper {
    static readonly MinUzunluk = 8;

    /** Politika bu ortamda zorlanıyor mu? Kapalıysa checklist gizlenir ve gecerliMi daima true döner. */
    static zorunluMu(): boolean {
        return EnvironmentHelper.parolaPolitikasiZorunluMu();
    }

    static kurallar(parola: string | null | undefined): IPasswordPolicyRule[] {
        const p = parola ?? "";

        return [
            { gecerli: p.length >= PasswordPolicyHelper.MinUzunluk, mesaj: `En az ${PasswordPolicyHelper.MinUzunluk} karakter` },
            { gecerli: /\p{Ll}/u.test(p), mesaj: "En az bir küçük harf" },
            { gecerli: /\p{Lu}/u.test(p), mesaj: "En az bir büyük harf" },
            { gecerli: /\p{Nd}/u.test(p), mesaj: "En az bir rakam" },
            { gecerli: /[^\p{L}\p{N}]/u.test(p), mesaj: "En az bir özel karakter (örn. ! @ # $ %)" },
        ];
    }

    static gecerliMi(parola: string | null | undefined): boolean {
        if (!PasswordPolicyHelper.zorunluMu())
            return true;

        return PasswordPolicyHelper.kurallar(parola).every(k => k.gecerli);
    }
}
